export default class AnalysisMortgagePeriod {
  constructor(interestAmount, balance) {
    this.interestAmount = interestAmount;
    this.balance = balance;
  }
}
